<template>
  <AForm v-bind="mergedProps" :class="['auth-form', $attrs.class]">
    <div class="auth-form__content">
      <slot />
    </div>

    <div v-if="$slots.actions" class="auth-form__actions">
      <slot name="actions" />
    </div>
  </AForm>
</template>

<script lang="ts" setup>
import { computed, useAttrs } from 'vue'
import type { FormProps } from 'ant-design-vue'

type UiFormProps = Partial<FormProps>

const props = withDefaults(defineProps<UiFormProps>(), {
  layout: 'vertical',
})

const mergedProps = computed(() => {
  const { onSubmit, ...rest } = useAttrs()
  return {
    ...props,
    ...rest,
  }
})
</script>

<style scoped lang="scss">
@use '@/assets/styles/media' as media;

.auth-form {
  display: flex;
  flex-direction: column;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__actions {
    display: flex;
    gap: 8px;
    margin: 16px 0 0 0;
  }

  @include media.max(media.$mobile) {
    justify-content: space-between;
    height: 100%;
  }
}
</style>
